import { render, staticRenderFns } from "./DialogVideoListTeacher.vue?vue&type=template&id=360491e0&"
import script from "./DialogVideoListTeacher.vue?vue&type=script&lang=js&"
export * from "./DialogVideoListTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports